// React and Router
import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'

// Form and Validation
import { Field, FormikProvider, useFormik } from 'formik'
import * as Yup from 'yup'

// Components
import Input from '../../../components/common/CustomInput'

// API/Services
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email format')
    .required('Email is required'),
})

const ForgetPassword = () => {
  const [error, setError] = useState('')
  const [IsEmailSend, setEmailSend] = useState(false)

  const handleSubmit = async (values) => {
    try {
      await axiosAuthInstance.post('/forget-password', values)
      setEmailSend(true)
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setError(error.response.data.message)
      } else {
        setError('An unexpected error occurred. Please try again.')
      }
    }
  }

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema,
    onSubmit: (values, formikHelpers) => handleSubmit(values, formikHelpers),
  })

  return (
    <div className='flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8'>
      <div className='sm:mx-auto sm:w-full sm:max-w-sm'>
        <h2 className='mt-10 text-center text-2xl font-bold leading-9 tracking-tight '>
          Forget Password
        </h2>
      </div>
      {IsEmailSend ? (
        <div class='max-w-md text-center mx-auto'>
          <p class='text-gray-600 text-center mt-2'>
            A reset password link has been sent to your email address.{' '}
            <b> Check Your Email</b>
          </p>
        </div>
      ) : (
        <div className='sm:mx-auto sm:w-full sm:max-w-sm mt-10'>
          <FormikProvider value={formik}>
            <form onSubmit={formik.handleSubmit}>
              <div className='flex flex-col gap-6'>
                <Field
                  name='email'
                  type='email'
                  label='Email'
                  placeholder='Email'
                  component={Input}
                />
              </div>

              {error && (
                <div className='text-red-700 text-sm sm:text-base font-normal mt-6 break-words'>
                  {error}
                </div>
              )}

              <div className='mt-6'>
                <button
                  type='submit'
                  disabled={formik.isSubmitting}
                  className='flex w-full justify-center rounded-md text-lg font-semibold text-white bg-prime shadow-sm disabled:bg-prime/80  px-4 py-3 mt-4'
                >
                  Submit
                </button>
              </div>
              <div className='text-sm mt-5 flex gap-1 '>
                <p>I have an account</p>
                <NavLink
                  to='/login'
                  className='font-semibold text-[#EF4044] hover:text-[#EF4044]'
                >
                  login
                </NavLink>
              </div>
            </form>
          </FormikProvider>
        </div>
      )}
    </div>
  )
}

export default ForgetPassword
